<template>
  <v-container fluid>
    <!-- The items -->
    <v-layout justify-center wrap>
      <v-flex
        v-for="(item, index) in itemsWithoutDuplicity"
        :key="index"
        xs12
        sm6
        md4
        lg3
        xl2
        class="pa-2"
      >
        <v-item-card :item="item" />
      </v-flex>
    </v-layout>
    <!-- The button to load more -->
    <v-layout class="mt-5" justify-center>
      <!-- The button itself -->
      <v-flex shrink v-if="items.length < itemsTotal || loadingItemsTotal">
        <v-btn
          @click="getItems"
          color="deep-purple"
          dark
          round
          :loading="loadingItems || loadingItemsTotal"
        >
          <v-icon class="mr-2">get_app</v-icon>
          <span>Cargar {{ itemsFetch }} items más (Hay {{ items.length }} de {{ itemsTotal }}</span>
          <span v-if="numDuplicated > 0">, con {{ numDuplicated }} duplicados)</span>
          <span v-else>)</span>
        </v-btn>
      </v-flex>
      <!-- A message to show when there are no more items -->
      <v-flex
        v-else
        class="blue-grey--text font-italic"
        shrink
      >Hemos cargado los {{ items.length }} items (ocultos {{ numDuplicated }} items duplicados)</v-flex>
    </v-layout>
    <!-- The save button that is placed at a fixed position -->
    <v-infinite-items-save-button />
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters, mapState } = createNamespacedHelpers(
  "classifier"
);

import VInfiniteItemsSaveButton from "./InfiniteItemsSaveButton";
import VItemCard from "../../../../components/ItemCard";

export default {
  components: {
    VInfiniteItemsSaveButton,
    VItemCard
  },
  computed: {
    ...mapGetters(["itemsWithoutDuplicity"]),
    ...mapState([
      "items",
      "itemsFetch",
      "itemsTotal",
      "loadingItems",
      "loadingItemsTotal"
    ]),
    numDuplicated() {
      return this.items.length - this.itemsWithoutDuplicity.length;
    }
  },
  methods: {
    ...mapActions(["getItems"])
  }
};
</script>